import { composeInfiniteQueryKey } from './composeInfiniteQueryKey.js';
import { composeQueryKey } from './composeQueryKey.js';
import { shelfMerge } from './shelfMerge.js';

/**
 * Calls a query client fetch method with parameters and options,
 * and automatically composes the `QueryKey` based on the schema and parameters.
 */ function callQueryClientMethodWithQueryKey(queryFilterMethod, schema, infinite, args) {
    const [{ requestFn, baseUrl, parameters, ...options }, queryClient] = args;
    if (!queryClient) throw new Error('queryClient is required');
    if (!queryClient[queryFilterMethod]) throw new Error(`queryClient is invalid, ${queryFilterMethod} method does not exist`);
    if (options.queryKey && parameters) {
        throw new Error('callQueryClientMethodWithQueryKey: options.queryKey and options.parameters are mutually exclusive');
    }
    if (options.queryFn && requestFn) {
        throw new Error('callQueryClientMethodWithQueryKey: options.queryFn and requestFn are mutually exclusive');
    }
    const queryFn = options.queryFn ?? (requestFn ? function({ queryKey: [, queryParams], signal, meta, pageParam }) {
        return requestFn(schema, {
            parameters: infinite ? shelfMerge(2, queryParams, pageParam) : queryParams,
            baseUrl,
            signal,
            meta
        });
    } : undefined);
    if (parameters) {
        // @ts-expect-error - Too complex union to type
        return queryClient[queryFilterMethod]({
            ...options,
            // Event if queryFn is undefined, it will override the default queryFn from `setQueryDefaults(...)`
            ...queryFn ? {
                queryFn
            } : {},
            queryKey: infinite ? composeInfiniteQueryKey(schema, parameters) : composeQueryKey(schema, parameters)
        });
    }
    // @ts-expect-error - Too complex union to type
    return queryClient[queryFilterMethod]({
        ...options,
        queryFn
    });
}

export { callQueryClientMethodWithQueryKey };
//# sourceMappingURL=callQueryClientFetchMethod.js.map
